/**
 * Supabase connection for the Street 60 leaderboard.
 *
 * Both values are safe to ship in client code: the publishable key identifies
 * the project and grants only what row level security allows — read the board,
 * append a run. It can never update or delete an existing row.
 *
 * Never put a service_role key or the database password here: anything in this
 * file ends up in the browser bundle.
 */
export const SUPABASE_URL = 'https://siqfcnvxfavpeopglbzi.supabase.co';

export const SUPABASE_PUBLISHABLE_KEY =
  'sb_publishable_VL-k4v3-3Qt2AkYpdZUDSQ_MKtdrbo1';
